import * as React from 'react';
import { Link } from 'gatsby';
import { useIntl } from 'react-intl';
import { NavLinkProps } from './types';
import Dropdown from './assets/dropdown.inline.svg';
import ExternalLink from '../ExternalLink';
import * as styles from './NavLink.module.scss';

function preventClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
}

export default function Content({
    to,
    external,
    label,
    subItems,
    tabIndex,
    toggleSubmenu,
}: NavLinkProps) {
    const { formatMessage } = useIntl();
    const isExternal =
        external || to?.startsWith('http') || to?.startsWith('//');

    const handleIconButtonClick = (
        event:
            | React.MouseEvent<HTMLAnchorElement>
            | React.KeyboardEvent<HTMLAnchorElement>,
    ) => {
        if ('key' in event && (event.key === 'Enter' || event.key === ' ')) {
            event.preventDefault();
            toggleSubmenu?.();
        }
    };

    if (subItems && subItems.length > 0) {
        /* eslint-disable jsx-a11y/anchor-is-valid */
        return (
            <>
                {Boolean(to) && to !== '/' ? (
                    <Link
                        to={to}
                        className={styles.root}
                        activeClassName={styles.active}
                        tabIndex={tabIndex}
                        role="menuitem"
                    >
                        {label}
                    </Link>
                ) : (
                    <a
                        href="#"
                        onClick={preventClick}
                        onKeyDown={handleIconButtonClick}
                        className={styles.root}
                        role="button"
                        aria-label="Toggle Submenu"
                        tabIndex={tabIndex}
                    >
                        {label}
                    </a>
                )}
                <a
                    href="#"
                    onClick={preventClick}
                    className={styles.iconButton}
                    onKeyDown={handleIconButtonClick}
                    role="button"
                    aria-label="Toggle Submenu"
                >
                    <Dropdown className={styles.dropdown} />
                </a>
                <ul className={styles.subMenu} role="menu">
                    {subItems.map((subItem) => (
                        <li key={subItem.to} role="menuitem">
                            <Content {...subItem} tabIndex={tabIndex} />
                        </li>
                    ))}
                </ul>
            </>
        );
    }
    return isExternal ? (
        <ExternalLink
            tabIndex={tabIndex}
            href={to}
            className={styles.root}
            aria-label={formatMessage({ id: 'nav.opensInNewTab' })}
            role="menuitem"
        >
            {label}
        </ExternalLink>
    ) : (
        <Link
            tabIndex={tabIndex}
            to={to}
            className={styles.root}
            activeClassName={styles.active}
            role="menuitem"
        >
            {label}
        </Link>
    );
}
